/** API case-request category: Right to Information Requests (Case Type 8) */
export const RIGHT_TO_INFORMATION_CATEGORY_CODE = 'RTI';
export const FILE_CATEGORY_RIGHT_TO_INFORMATION = 'Right to Information';

/** Set when file categories load from API; used for id-based routing once known. */
export let RIGHT_TO_INFORMATION_CATEGORY_ID = '';

export function setRightToInformationCategoryId(id: string) {
  RIGHT_TO_INFORMATION_CATEGORY_ID = id.trim();
}

export function isRightToInformationCategory(item: {
  id?: string;
  name?: string;
  code?: string;
}): boolean {
  const code = (item.code ?? '').trim().toUpperCase();
  const name = (item.name ?? '').trim().toLowerCase();
  if (
    code === RIGHT_TO_INFORMATION_CATEGORY_CODE ||
    code === 'RIGHT_TO_INFORMATION' ||
    code.includes('RIGHT_TO_INFORMATION')
  ) {
    return true;
  }
  if (RIGHT_TO_INFORMATION_CATEGORY_ID && item.id === RIGHT_TO_INFORMATION_CATEGORY_ID) return true;
  if (name.includes('right to information') || name.includes('right to inform') || name === 'rti') return true;
  return false;
}

export const RIGHT_TO_INFORMATION_WIZARD_STEPS = [
  { n: 1, lbl: 'Case Overview' },
  { n: 2, lbl: 'Timeline' },
  { n: 3, lbl: 'Submission' },
  { n: 4, lbl: 'Upload Documents' },
] as const;

export type RightToInformationWizardStep = (typeof RIGHT_TO_INFORMATION_WIZARD_STEPS)[number]['n'];

/** Static fallback when lookup APIs are unavailable (Data Capture v1.3). */
export const PREFERRED_METHOD_OF_ACCESS_FALLBACK = [
  { id: 'inspect-in-person', name: 'Inspect documents/records in person', code: 'INSPECT_IN_PERSON' },
  {
    id: 'receive-copies',
    name: 'Receive copies of documents or records (notes, extracts, or certified copies)',
    code: 'RECEIVE_COPIES',
  },
  { id: 'certified-samples', name: 'Receive certified samples of material', code: 'CERTIFIED_SAMPLES' },
  {
    id: 'digital-or-printed',
    name: 'Receive in digital or printed format (CD/DVD/USB/email/printouts, etc.)',
    code: 'DIGITAL_OR_PRINTED',
  },
] as const;

export const PREFERRED_LANGUAGE_FALLBACK = [
  { id: 'english', name: 'English', code: 'ENGLISH' },
  { id: 'sinhala', name: 'Sinhala', code: 'SINHALA' },
  { id: 'tamil', name: 'Tamil', code: 'TAMIL' },
] as const;
